export default __webpack_public_path__ + "static/media/certificado-minicurso-ecg.bc4b18c1.svg";